<!-- TEMPLATE -->
<template>
  <div class="wrapper">
    <dean-dialog
            title="Offerte verwijderen"
            :addClose="true"
            @close="close"
    >Weet u zeker dat u de volledige offerte wenst te verwijderen?
      <span slot="dean-dialog-button-group">
          <dean-button :warning="true" :dialog-button="true" @click.native="close()">Nee</dean-button>
          <dean-button :success="true" :dialog-button="true" @click.native="remove()">Ja</dean-button>
      </span>
    </dean-dialog>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
  import Vue from 'vue';
  import axios from 'axios';
  import { Component, Prop } from 'vue-property-decorator';
  import {
    // SVG
    warningIcon,
    saveIcon,
    // COMPONENTS
    deanDialog,
    deanDialogButtonGroup,
  } from '@deanone/dean-components';
  import deanButton from '@/components/deanComponents/deanButton.vue';
  import DeanNotification from '@/components/deanComponents/deanNotification.vue';
  import { deanDialogBus } from '@/main';

  @Component({
    components: {
      warningIcon,
      saveIcon,
      DeanNotification,
      deanDialog,
      deanButton,
      deanDialogButtonGroup,
    },
  })

  export default class QuoteRemoveDialog extends Vue {
    private readonly removeUrl: string = '/-/trade/api/quote.remove';

    // METHODS
    public close() {
      deanDialogBus.$emit('close');
    }

    public remove() {
      axios.post(this.removeUrl, {
          id: this.$route.params.id,
      }).then(
        (response) => {
          this.$toast({
            icon: saveIcon,
            text: 'Offerte verwijderd',
            theme: 'success',
            title: 'Verwijderd',
          });
          this.$router.push({name: 'quotes'});
          deanDialogBus.$emit('close');
        },
        (error) => {
          // tslint:disable-next-line:no-console
          console.error(error);
          deanDialogBus.$emit('close');
        },
      );
    }
  }
</script>

<!-- STYLE -->
<style lang="scss" scoped>
  // IMPORT
  @import '~@deanone/dean-components/src/scss/vars';

  :deep(.dean-load-overlay) {
    width: 100%;
    height: 100%;
    position: absolute;

    .dean-overlay {
      position: absolute;
    }
  }
</style>
